import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_WIDTH = 12;
const DEFAULT_HEIGHT = 12;

function IconSlimArrowDown({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg class={cssClass} width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={color} d="M5.5 2a.5.5 0 0 1 1 0v6.793l2.646-2.647a.5.5 0 1 1 .707.708l-3.5 3.5a.5.5 0 0 1-.707 0l-3.5-3.5a.5.5 0 0 1 .63-.772l.077.064L5.5 8.793V2z"/>
        </svg>
    );
}

IconSlimArrowDown.defaultProps = {
    color: "var(--label-accent)",
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT
};

export default IconSlimArrowDown;
